// Module
var code = "<div class=\"row\"> <div class=\"col-xs-12\"> <a class=\"btn btn-default\" href=\"https://manager.vip.symantec.com/vipmgr/signin.v\" target=\"_blank\"> Access VIP Manager <i class=\"fa fa-external-link icon-md\"></i> </a> </div> </div> ";
// Exports
module.exports = code;